// extracted by mini-css-extract-plugin
module.exports = {"chooser":"KidChooser_chooser__-WkTK","chooser__item":"KidChooser_chooser__item__1zCnG","chooser__item_active":"KidChooser_chooser__item_active__1oCG2"};